import React from 'react';

import EmojiNeutralIcon from '@atlaskit/icon/core/emoji-neutral';

export const ToneNeutralIcon = (): React.JSX.Element => (
	<EmojiNeutralIcon color="currentColor" label="" spacing="spacious" />
);
